/* eslint-disable */
import React, {PropTypes} from 'react';
import ConfigD from './util/ConfigD';
import { Link } from 'react-router';

const ProtocoloCadastradoMsgSAC = (props) =>{
    
    if((window.location.hostname === 'www.sac.sebrae.com.br')){
        return   <p>O SAC do Sebrae esclarece que esse acesso somente é possível com a utilização do número da manifestação e da senha fornecidos acima. Ambos são particulares e intransferíveis.</p>
    }else{
        return <p>A Ouvidoria esclarece que esse acesso somente é possível com a utilização do número da manifestação e da senha fornecidos acima. Ambos são particulares e intransferíveis.</p>

    }

}
export default ProtocoloCadastradoMsgSAC;



/** WEBPACK FOOTER **
 ** ./src/components/ProtocoloCadastradoMsgSAC.js
 **/